<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent.mainWrapper-leftContent--fullWidth
    BreadCrumb(:breadcrumbList='breadcrumbs' normal)
    PublicArticle(:staticData='data')
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import PublicArticle from '@/components/public_article/public_article.vue'
export default {
  props: {
    data: Object,
    breadcrumbList: Array
  },
  components: {
    BreadCrumb,
    PublicArticle
  },
  data() {
    return {
      breadcrumbs: JSON.parse(JSON.stringify(this.breadcrumbList))
    }
  },
  created() {
    this.breadcrumbs.push({
      text: '公共事務',
      link: '/gov-announces'
    })
  }
}
</script>
